import { Fragment } from 'react'
import { withRouter } from 'react-router'
import { BreadCrumb } from 'components'
import { Layout } from 'antd'
import styles from './PrimaryLayout.module.scss';

const { Content } = Layout


const MobileLayout = (props) => {
  const { children, isAuthenticated } = props;
 

  return (
    <Fragment>
      <Layout hasSider={true}>

        <div
          className={styles.container}
          id="primaryLayout"
        >
          <Content className={styles.content}>
            {isAuthenticated && <BreadCrumb />}
            {children}
          </Content>
        </div>
      </Layout>
    </Fragment>
  )

}

export default withRouter(MobileLayout)

